const taxTypeEnum = Object.freeze({
    FIXED: 5,
    PERCENTAGE: 10,
});
export default taxTypeEnum;
